export var ANALYTICS_MEDIA_CHANNEL = 'media';